import { isDevelopmentEnv } from 'shared/constants'
import config from 'config'
import { FragmentRootOptions, LogLevelNames } from '@vp/ubik-fragment-types'

const newRelicConfig = config.client.newRelic

// Ubik fragment doesn't support the newrelic browser agent locally, this function provides it
export const configureNewRelicLocalLogging = (rootOptions: FragmentRootOptions) => {
  if (rootOptions?.loggerOptions && isDevelopmentEnv && newRelicConfig.enableLocally) {
    return {
      ...rootOptions,
      loggerOptions: {
        ...rootOptions.loggerOptions,
        newrelicApplicationId: newRelicConfig.applicationId,
        newrelicLicenseKey: newRelicConfig.licenseKey,
        microAgentLogLevel: newRelicConfig.microAgentLogLevel as LogLevelNames,
      },
    }
  }

  return rootOptions
}
